import { useAppDispatch, useAppSelector } from "../../app/hooks";
import classes from "./BtcUserDk.module.css";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Chip,
  createTheme,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  IconButton,
  Snackbar,
  Stack,
  ThemeProvider,
  Tooltip,
  useMediaQuery,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useEffect } from "react";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import {
  logout,
  selectGrp,
  selectUsername,
} from "../../features/auth/authSlice";
import {
  createBtcDk,
  getAllBtcDk,
  getBtcDkLog,
  updateBtcDk,
} from "../../services/btc/btcApi";
import {
  addOrEditBtcDk,
  editBtcDk,
  selectBtc,
  setBtcDsDk,
  setBtcConfig,
  selectBtcConfig,
  addOrUpdateBtcDk,
} from "../../features/btc/btcSlice";
import { useState } from "react";
import { getYearCanChi } from "../../utils/amlich-hnd";
import { ConfirmButton } from "../dialog/ConfirmButton.js";
import { blueGrey, purple } from "@mui/material/colors";
import BtcMenu from "../Menu/BtcMenu.js";
import { getDateAL, ngayALToDL, renderLogDlg } from "./BtcUser.js";
import {
  getLunarMonthStartEnd2,

  MonthRangePicker,
} from "./ngayAl.js";
import { PanelCanvas } from "./PanelCanvas.js";
import BtcUserDk, { loadBtcConfig } from "./BtcUserDk.js";
import { EditMenu } from "./Btc.js";
import ReceiptIcon from "@mui/icons-material/Receipt";
import {
  collection,
  query,
  where,
  onSnapshot,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../firebase/firebase";
import CloseIcon from "@mui/icons-material/Close";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTheme } from "@emotion/react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {MyDlg} from "./MyDlg"
import {ImportDkStep} from "./ImportDkStep"
import { NotifySnackbar } from "../dialog/NotifySnackbar.js";
import { useNotify } from "../hooks/useNotify";

export const theme = createTheme({
  palette: {
    myprimary: blueGrey,
    mysecondary: purple,
  },
  components: {
    // Name of the component ⚛️
    MuiTextField: {
      defaultProps: {
        // The default props to change
        size: "small",
      },
    },
    MuiSelect: {
      defaultProps: {
        // The default props to change
        size: "small",
      },
    },
  },
});
export const MyBtcLayout = ({ title, footer, children }) => {
  return (
    <ThemeProvider theme={theme}>
      <div className={classes.layout}>
        <div className={classes.title}>{title}</div>
        <div className={classes.container}>{children}</div>
        <div className={classes.footer}>{footer}</div>
      </div>
    </ThemeProvider>
  );
};
export const BtcTitle = ({ navigate }) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUsername);
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <BtcMenu navi={navigate}></BtcMenu>
      <Typography>{user}</Typography>
      <Button size="small" onClick={() => dispatch(logout())}>
        Logout
      </Button>
    </div>
  );
};
function calcTotal(dk) {
  var y = 0;
  var d = 0;
  dk.dsQuy.forEach((q) => {
    if (q.donVi === "y") {
      y += parseInt(q.soLuong);
    } else if (q.donVi === "d") {
      d += parseInt(q.soLuong);
    }
  });
  const zTotal = `${formatN(y)}y, ${formatN(d)}d`;
  return zTotal;
}
export function formatN(n) {
  var ret = [];
  var sign = "";
  if (n < 0) {
    n = 0 - n;
    sign = "-";
  }
  while (n > 999) {
    ret.push((n % 1000).toString().padStart(3, "0"));
    n = parseInt(n / 1000);
  }
  ret.push(n);
  return sign + ret.reverse().join(".");
}
var Canvas = ({ bill, dsQuy, zoomable = false }) => (
  <PanelCanvas
    imgBase64={bill}
    parts={dsQuy
      .filter((quy) => quy.soLuong !== 0)
      .map((quy) => ({
        name: `${quy.msQuy}: ${quy.soLuong} ${quy.donVi}`,
        judge: true,
      }))}
    zoomable={zoomable}
  />
);

function btcDkFormFdData(fdDsQuy) {
  return fdDsQuy.map((txt) => {
    var arr = txt.split(",");
    return {
      msQuy: arr[0],
      soLuong: parseInt(arr[1]),
      donVi: arr[2],
    };
  });
}

const BtcAdmin = ({ navigate, params = {} }) => {
  console.log("BtcAdmin");
  const dispatch = useAppDispatch();

  // init
  const config = useAppSelector(selectBtcConfig);
  const btc = useAppSelector(selectBtc);
  const grp = useAppSelector(selectGrp);

  // snackbar
    const {
      notify,
      success: notifySuccess,
      error: notifyError,
      close,
    } = useNotify();

  const useSolar = true; // default to solar calendar, can switch to lunar if needed
  const [range, setRange] = useState({ from: null, to: null }); // for search

  // first day of month (in lunar)
  const [curDateAL] = useState(getDateAL());
  const [ngayAL] = useState(() => {
    if (btc.start) {
      return getDateAL(dayjs(btc.start));
    }
    return getDateAL();
  });

  // first day of month (in solar)
  const [ngayDL] = useState(() => {
    if (btc.start) {
      return btc.start;
    }
    return dayjs().startOf("month").format("YYYY-MM-DD");
  });
  console.log("initial ngayDL: ", ngayDL);

  const [curCV, setCurCV] = useState();
  const popupShowHide = !!curCV;

  const [btcLoading, setBtcLoading] = useState(true);
  const [configLoading, setConfigLoading] = useState(true);
  const [openImport, setOpenImport] = useState(false);

  // init range
  useEffect(() => {
    setRange({
      from: ngayDL,
      to: dayjs(ngayDL).endOf("month").format("YYYY-MM-DD"),
    });
  }, [ngayDL]);

  // subscribe
  useEffect(() => {
    var cnd = where("timestamp", ">=", Timestamp.now());
    const q = query(collection(db, `btc/${grp}/dk_log`), cnd);
    console.log("subcribe log: ", Timestamp.now().toDate().toLocaleString());
    const unsubscribe = onSnapshot(
      q,
      { includeMetadataChanges: true },
      (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const logId = change.doc.id;
          const { json, itemId, timestamp, action } = change.doc.data();
          console.log(
            `DK log: [${logId}] ${action} [${itemId}] at ${timestamp.toDate().toLocaleString()}`,
          );
          console.log("content: ", json);

          const changes = JSON.parse(json);
          if (changes.dsQuy !== undefined) {
            changes.dsQuy = btcDkFormFdData(changes.dsQuy);
          }

          const applied = apply();
          console.log(applied ? "applied" : "skipped");

          function apply() {
            if (action === "create") {
              const [startAl, endAl] = getLunarMonthStartEnd2(ngayAL);
              const [start, end] = [ngayALToDL(startAl), ngayALToDL(endAl)];
              if (changes.ngay >= start && changes.ngay <= end) {
                dispatch(addOrEditBtcDk({ id: itemId, btcDk: changes }));
                notifySuccess({
                  msg:
                    "Đã cập nhật thêm mới: " +
                    timestamp.toDate().toLocaleString(),
                });
                return true;
              }
            } else if (action === "update") {
              if (btc.btcDsDk.find((dk) => itemId === dk.id)) {
                dispatch(addOrEditBtcDk({ id: itemId, btcDk: changes }));
                notifySuccess({
                  msg:
                    "Đã cập nhật thay đổi: " +
                    timestamp.toDate().toLocaleString(),
                });
                return true;
              }
            }
          }
        });
      },
    );

    return unsubscribe;
  }, [btc.btcDsDk, dispatch, grp, ngayAL, notifySuccess]);

  // 1️⃣ Load BTC Data
  useEffect(() => {
    const loadBtcDsDk = async () => {
      setBtcLoading(true);

      try {
        const [startAl, endAl] = getLunarMonthStartEnd2(ngayAL);
        var [start, end] = [ngayALToDL(startAl), ngayALToDL(endAl)];

        if (useSolar) {
          start = range.from;
          end = range.to;
        }

        const isSameRange = start === btc.start && end === btc.end;
        const isAdminMode = !btc.email;

        if (isSameRange && isAdminMode) {
          console.log("skip load btcDsDk");
          return;
        }

        const res = await getAllBtcDk({ start, end, grp });
        if (!res.error) {
          dispatch(setBtcDsDk({ btcDsDk: res.result, start, end }));
        } else {
          console.error("getAllBtcDk error:", res.error);
        }
      } catch (err) {
        console.error("loadBtcDsDk failed:", err);
      } finally {
        setBtcLoading(false);
      }
    };

    loadBtcDsDk();
  }, [
    ngayAL,
    range.from,
    range.to,
    useSolar,
    btc.start,
    btc.end,
    btc.email,
    dispatch,
    grp,
  ]);

  // 2️⃣ Load Config
  useEffect(() => {
    const loadConfig = async () => {
      setConfigLoading(true);

      try {
        const [startAl] = getLunarMonthStartEnd2(ngayAL);
        var start = ngayALToDL(startAl);

        if (useSolar) {
          start = "default";
        }

        if (config.ngay === start) {
          console.log("skip load config");
          return;
        }

        const newConfig = await loadBtcConfig(start, grp);
        console.log("loadBtcConfig", newConfig);
        dispatch(setBtcConfig(newConfig));
      } catch (err) {
        console.error("loadBtcConfig failed:", err);
      } finally {
        setConfigLoading(false);
      }
    };

    loadConfig();
  }, [ngayAL, ngayDL, config.ngay, dispatch, grp, useSolar]);

  // 3️⃣ Prevent render until both are done
  if (btcLoading || configLoading) {
    return <div>Loading...</div>;
  }

  function handleAdd() {
    navigate("/BtcUserDk", {
      id: null,
      ngayAL: curDateAL.month === ngayAL.month ? curDateAL : ngayAL,
    });
  }

  const title = <BtcTitle navigate={navigate}></BtcTitle>;
  const dsDk = btc.btcDsDk.filter((dk) => !dk.deleted);
  dsDk.sort((a, b) => {
    var gioa = a.gio || "";
    var giob = b.gio || "";
    return a.ngay.localeCompare(b.ngay) || gioa.localeCompare(giob);
  });
  const dsDkGroupByMs = new Map();
  dsDk.forEach((dk) => {
    if (dk.boQua) {
      return;
    }
    dk?.dsQuy && dk.dsQuy.forEach((quy) => {
      if (dsDkGroupByMs.has(quy.msQuy)) {
        dsDkGroupByMs.get(quy.msQuy)[quy.donVi] += parseInt(quy.soLuong);
      } else {
        var newObj = { d: 0, y: 0 };
        newObj[quy.donVi] += parseInt(quy.soLuong);
        dsDkGroupByMs.set(quy.msQuy, newObj);
      }
    });
  });
  var msQuyLst = Array.from(dsDkGroupByMs.keys());
  msQuyLst.sort();
  var dsDkTotal = { y: 0, d: 0 };
  msQuyLst.forEach((key) => {
    var value = dsDkGroupByMs.get(key);
    dsDkTotal.d += value.d;
    dsDkTotal.y += value.y;
  });

  const footer = (
    <Box sx={{display: "flex", gap: 1}}>
      <Button onClick={()=>setOpenImport(true)}>Import</Button>
    <EditMenu
      options={[
        { cb: () => handleExport(["y", "d"]), label: "Tất cả" },
        { cb: () => handleExport(["y"]), label: "Yên" },
        { cb: () => handleExport(["d"]), label: "Đồng" },
      ]}
    >
      {"Sao chép"}
    </EditMenu></Box>
  );
  const screenOrientation = 0; // 0:landscape
  async function handleDelete(id) {
    // var { error } = await removeBtcDk(id);
    // if (!error) {
    //   dispatch(deleteBtcDk({ id }));
    // }
    var changes = { deleted: true };
    var { error } = await updateBtcDk(id, changes, grp);
    if (!error) {
      dispatch(editBtcDk({ id, changes }));
    }
  }
  async function handleCheck(id, checked) {
    var changes = { xacNhan: checked };
    var { error } = await updateBtcDk(id, changes, grp);
    if (!error) {
      dispatch(editBtcDk({ id, changes }));
    }
  }
  async function handleChange(id, changes) {
    var { error } = await updateBtcDk(id, changes, grp);
    if (!error) {
      dispatch(editBtcDk({ id, changes }));
    }
  }
  async function handleSkip(id, checked) {
    var changes = { boQua: checked };
    // var { error } = await updateBtcDk(id, changes);
    // if (!error) {
    dispatch(editBtcDk({ id, changes }));
    // }
  }
  async function handleExport(options) {
    var lines = [
      "id\tngay\temail\t" + msQuyLst.join("\t") + "\ttong\txac nhan\tghi chu",
    ];

    // `${value.y}y ${value.d}d`
    var formatValue = (value) =>
      options.length === 1
        ? value[options[0]]
        : options.map((dv) => value[dv] + dv).join(";");
    dsDk.forEach((dk) => {
      if (dk.boQua) {
        return;
      }

      var dkGroupByMs = new Map();
      var dkTotal = { y: 0, d: 0 };
      msQuyLst.forEach((ms) => dkGroupByMs.set(ms, { y: 0, d: 0 }));
      dk.dsQuy.forEach((quy) => {
        dkGroupByMs.get(quy.msQuy)[quy.donVi] += quy.soLuong;
        dkTotal[quy.donVi] += quy.soLuong;
      });
      var line = msQuyLst.map((key) => formatValue(dkGroupByMs.get(key)));
      lines.push(
        `${dk.id}\t${dk.ngay}\t${dk.email}\t` +
          line.join("\t") +
          `\t${formatValue(dkTotal)}\t${dk.xacNhan}\t${dk.note}`,
      );
    });

    // sum
    var lineSum = msQuyLst.map(
      (key) => formatValue(dsDkGroupByMs.get(key)), //`${dsDkGroupByMs.get(key).y}y ${dsDkGroupByMs.get(key).d}d`
    );
    lines.push(
      `\t\t\t` + lineSum.join("\t") + `\t${formatValue(dsDkTotal)}\t\t`,
    );
    await navigator.clipboard.writeText(lines.join("\n"));
  }

  var soDuTkObj = { y: 0, d: 0 };
  const lst = dsDk
    .toSorted((a, b) => a.ngay - b.ngay)
    .map((dk) => {
      if (dk.xacNhan && !dk.boQua) {
        dk.dsQuy.forEach((quy) => {
          soDuTkObj[quy.donVi] += parseInt(quy.soLuong);
        });
      }
      return {
        soDuTk: `${formatN(soDuTkObj.y)}y, ${formatN(soDuTkObj.d)}d`,
        dk,
      };
    });

  // const handleCloseSB = (event, reason) => {
  //   if (reason === "clickaway") {
  //     return;
  //   }

  //   setOpenSB(false);
  // };
  // const action = (
  //   <>
  //     {/* <Button color="secondary" size="small" onClick={handleCloseSB}>
  //       UNDO
  //     </Button> */}
  //     <IconButton
  //       size="small"
  //       aria-label="close"
  //       color="inherit"
  //       onClick={handleCloseSB}
  //     >
  //       <CloseIcon fontSize="small" />
  //     </IconButton>
  //   </>
  // );

  function handleSearch({ from, to }) {
    setRange({ from, to });
  }

  async function handleImport(records) {
    const newLst = [];
    const errors = [];
    const createdDks = [];
    const ids = new Set(dsDk.map((m) => m.id));
    records.forEach((r) => {
      if (ids.has(r.id)) {
        // existing
        errors.push(`DK ${r.id} existing`);
      } else {
        newLst.push(r);
      }
    });

    const results = await Promise.all(
      newLst.map(async (r) => {
        if (r.id.startsWith("tmp_")) {
          const { id, ...body } = r;
          const { error, result } = await createBtcDk(body, grp);
          if (error) {
            console.log(`create DK ${r.ngay} ${r.emal} error: ${error}`);
            errors.push(error);
            return { error };
          } else {
            createdDks.push(result);
            return { result };
          }
        } else {
          return { result: r };
        }
      }),
    );

    const imported = results.map((r) => r.result).filter(Boolean);
    console.log("handle import: ", { errors, createdDks, imported });

    dispatch(addOrUpdateBtcDk(imported));
    
    // notify
    if (imported.length < results.length) {
      notifyError(`Imported ${imported.length}/${results.length}`);
    } else {
      notifySuccess(`Imported ${imported.length}`);
    }

    // close import dialog
    setOpenImport(false);
  }

  return (
    <MyBtcLayout title={title} footer={footer}>
      <Stack
        direction={"column"}
        spacing={{ xs: 1, sm: 2 }}
        sx={
          screenOrientation
            ? { display: "flex", flexDirection: "column", height: "100%" }
            : {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                overflow: "auto",
              }
        }
      >
        {/* {LularDatePicker2(ngayAL, setNgayAl)} */}
        <MonthRangePicker
          from={range.from}
          to={range.to}
          onSearch={handleSearch}
        ></MonthRangePicker>
        <Stack
          direction={"column"}
          spacing={{ xs: 1, sm: 2 }}
          style={
            screenOrientation
              ? { flexGrow: 8, overflow: "auto" }
              : { flexGrow: 8 }
          }
        >
          <Stack direction={"column"} spacing={{ xs: 1, sm: 2 }}>
            {lst.map(({ dk, soDuTk }, i) => (
              <BtcDkCard2
                key={i}
                id={i}
                dk={dk}
                setCurCV={setCurCV}
                handleCheck={handleCheck}
                handleSkip={handleSkip}
                handleDelete={handleDelete}
                handleChange={handleChange}
                soDuTk={soDuTk}
                navigate={navigate}
              ></BtcDkCard2>
            ))}
          </Stack>
          <Box
            style={{
              padding: "1rem",
              display: "flex",
              justifyContent: "center",
              backgroundColor: "aliceblue",
            }}
          >
            <IconButton onClick={handleAdd}>
              <AddIcon></AddIcon>
            </IconButton>
          </Box>
          <Stack spacing={{ xs: 1, sm: 2 }} direction={"column"}>
            <Typography variant="h5" fullwidth="true">{`Tổng cộng: ${formatN(
              dsDkTotal.y,
            )}y ${formatN(dsDkTotal.d)}d`}</Typography>
            <Stack
              spacing={{ xs: 1, sm: 2 }}
              direction={"row"}
              flexWrap={"wrap"}
            >
              {msQuyLst.map((key) => {
                var value = dsDkGroupByMs.get(key);
                var tenQuy = "";
                try {
                  tenQuy = config.dsQuy.find(
                    (item) => item.msQuy === key,
                  ).tenQuy;
                } catch (error) {
                  console.log("not found: " + key);
                }
                return (
                  <Tooltip key={key} title={tenQuy}>
                    <Chip
                      key={key}
                      avatar={<Avatar>{key}</Avatar>}
                      label={`${formatN(value.y)}y, ${formatN(value.d)}d`}
                    />
                  </Tooltip>
                );
              })}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <Dialog
        open={popupShowHide}
        onClose={() => setCurCV()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: { xs: "100%", sm: "fit-content" },
              maxWidth: "100%",
            },
          },
          textAlign: "center",
        }}
      >
        <DialogContent>{curCV}</DialogContent>
        <DialogActions>
          <Button onClick={() => setCurCV()} autoFocus>
            {"Đóng"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* notify */}
      <NotifySnackbar notify={notify} onClose={close} />
      {/* <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={!!openSB}
        autoHideDuration={6000}
        onClose={handleCloseSB}
        message={openSB.msg}
        action={action}
      /> */}
      <MyDlg title={"Import DK"} open={openImport} onClose={() => setOpenImport(false)}>
        <ImportDkStep onImport={handleImport} />
      </MyDlg>
    </MyBtcLayout>
  );
};

export default BtcAdmin;
const TextItem = ({ children, ...props }) => {
  return (
    <Typography sx={{ whiteSpace: "nowrap" }} {...props}>
      {children}
    </Typography>
  );
};

export function PdfModal({ open, onClose, src }) {
  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogContent
        sx={{
          p: 0,
          position: "relative",
          bgcolor: "black",
        }}
      >
        {/* CLOSE BUTTON */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 10,
            bgcolor: "rgba(0,0,0,0.6)",
            color: "#fff",
            "&:hover": {
              bgcolor: "rgba(0,0,0,0.8)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* PDF IFRAME */}
        <iframe
          src={src}
          title="PDF viewer"
          style={{
            width: "100%",
            height: "100vh",
            border: "none",
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
const BtcDkCard2 = ({
  dk,
  setCurCV,
  handleDelete,
  handleCheck,
  handleSkip,
  handleChange,
  navigate,
  soDuTk = "---",
  // dkLog, setDkLog = ()=>{},
  ...props
}) => {
  // console.log("BtcDkCard2");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [dkLog, setDkLog] = useState();
  const grp = useAppSelector(selectGrp);
  const [openPdf, setOpenPdf] = useState(false);

  async function handleLog(id) {
    // get log
    const { result, error } = await getBtcDkLog({ itemId: id, grp });
    if (error) {
      console.error(error);
    } else {
      setDkLog({ id, logs: result });
    }
    // show log
    console.log(result);
  }
  const [editingDkId, setEditingDkId] = useState();
  function handleEdit(id) {
    if (window.innerWidth < 500) {
      navigate("/BtcUserDk", { id: id });
    } else {
      setEditingDkId(id);
    }
  }
  const ngayDL = dayjs(dk.ngay);
  const ngayAL = getDateAL(ngayDL);
  const gio = dk.gio ? dk.gio.slice(0, 5) : "00:00";
  const hasBill = Boolean(dk.bill);

  const isImage = dk?.bill?.startsWith("data:image/");
  const isPdf = dk?.bill?.startsWith("data:application/pdf");

  return (
    <div
      {...props}
      style={{
        backgroundColor: dk.bill ? "whitesmoke" : "yellow",
      }}
    >
      <Stack
        spacing={{ xs: 1, sm: 2 }}
        direction={{ xs: "column", sm: "row" }}
        sx={
          dk.flag === 1
            ? { backgroundColor: theme.palette.warning.light }
            : dk.xacNhan
              ? { backgroundColor: theme.palette.primary.light }
              : {}
        }
      >
        <Stack
          minWidth={300}
          spacing={{ xs: 1, sm: 2 }}
          direction={{ xs: "row", sm: "row" }}
          sx={{ justifyContent: "space-between" }}
        >
          <div style={{ padding: "0.5rem" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <TextItem variant="h6">{`${ngayDL.format("YYYY.MM.DD")}`}</TextItem> */}

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={ngayDL}
                  format="YYYY.MM.DD"
                  // disableOpenPicker
                  onAccept={(value) => {
                    handleChange(dk.id, {
                      ngay: value ? value.format("YYYY-MM-DD") : null,
                    });
                  }}
                  slotProps={{
                    textField: {
                      variant: "standard",
                      size: "small",
                      sx: {
                        width: 130, // 👈 thu hẹp chiều rộng
                      },
                      InputProps: {
                        disableUnderline: true,
                        sx: {
                          fontSize: "large", // 👈 chữ nhỏ hơn
                          padding: 0, // 👈 bỏ padding mặc định
                          minHeight: "auto",
                          "& input": { padding: 0 },
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>

              {/* <IconButton onClick={() => handleLog(dk.id)}>
                <InfoIcon />
              </IconButton> */}
            </div>

            <TextItem
              onClick={() => handleLog(dk.id)}
              sx={{
                color: "primary.main",
                cursor: "pointer",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              {`${gio} ${ngayAL.day}/${ngayAL.month}/${getYearCanChi(ngayAL.year)}`}
            </TextItem>

            <TextItem>{`${dk.email.replace("@gmail.com", "")}`}</TextItem>
          </div>
          <div
            style={{
              padding: "0.5rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <TextItem variant="h6" sx={{ display: "inline-block" }}>
              {calcTotal(dk)}
            </TextItem>
            <TextItem>{soDuTk}</TextItem>
          </div>
        </Stack>

        <Stack
          flexGrow={1}
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 1, sm: 2 }}
        >
          {(hasBill || (!isMobile)) && <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height={{ sm: 50 }}
            minWidth={50}
            p={1}
            sx={{
              margin: "0.5rem",
              borderRadius: 1,
              bgcolor: hasBill ? "transparent" : "grey.100",
              border: hasBill ? "none" : "1px dashed",
              borderColor: "grey.300",
              cursor: hasBill ? "pointer" : "default",
              pointerEvents: hasBill ? "auto" : "none", // ✅ khóa click khi không có bill
              "&:hover": hasBill ? { bgcolor: "grey.50" } : {},
            }}
          >
            {isImage ? (
              /* ✅ Có bill → show ảnh */
              /* IMAGE */
              <Box
                component="img"
                src={dk.bill}
                alt="bill"
                sx={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
                onClick={() =>
                  setCurCV(<Canvas dsQuy={dk.dsQuy} bill={dk.bill} zoomable />)
                }
              />
            ) : isPdf ? (
              <Box sx={{ maxHeight: 320, overflow: "auto" }}>
                <Box p={1} display="flex" flexDirection="column" alignItems="center" gap={0.5}
                  onClick={() => setOpenPdf(true)}
                  sx={{
                    cursor: "pointer",
                    borderRadius: 2,
                    overflow: "hidden",
                    border: "1px solid",
                    borderColor: "grey.300",
                  }}
                >
                  <PictureAsPdfIcon color="error" sx={{ fontSize: 48 }} />
                  <Typography variant="caption" color="text.secondary">
                    Xem PDF
                  </Typography>
                </Box>
              </Box>
            ) : (
              /* ✅ Không có bill */
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={0.5}
              >
                <ReceiptIcon fontSize="small" sx={{ color: "grey.400" }} />
                <Typography variant="caption" color="text.secondary">
                  Chưa có bill
                </Typography>
              </Box>
            )}
          </Box>}

          {dk.note && (
            <Box
              component={"div"}
              width={{ xs: "100%", sm: 200 }}
              padding={"0.5rem"}
            >
              {"Ghi chú: " + dk.note}
            </Box>
          )}
          <Stack
            spacing={{ xs: 1, sm: 2 }}
            direction={"row"}
            flexWrap={"wrap"}
            flexGrow={1}
            padding={"0.5rem"}
            width={300}
          >
            {dk.dsQuy.map((quy, j) => (
              <Chip
                key={j}
                avatar={<Avatar>{quy.msQuy}</Avatar>}
                label={`${formatN(quy.soLuong)}${quy.donVi}`}
              />
            ))}
          </Stack>
        </Stack>
        <Stack direction={"row"} sx={{ justifyContent: "space-between" }}>
          <Box className={classes.row_y_center} m={1}>
            <FormControlLabel
              label="Xác nhận"
              sx={{ whiteSpace: "nowrap" }}
              control={
                <Checkbox
                  checked={!!dk.xacNhan}
                  onChange={(e) => handleCheck(dk.id, e.target.checked)}
                />
              }
            />
            <FormControlLabel
              label="Bỏ qua"
              sx={{ whiteSpace: "nowrap" }}
              control={
                <Checkbox
                  checked={!!dk.boQua}
                  onChange={(e) => handleSkip(dk.id, e.target.checked)}
                />
              }
            />
          </Box>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Button size="small" onClick={() => handleEdit(dk.id)}>
              {"Sửa"}
            </Button>
            <ConfirmButton
              onOk={() => handleDelete(dk.id)}
              title={"Xác nhận xóa"}
              message={"Bạn có muốn xóa không?"}
            >
              <Button size="small">{"Xóa"}</Button>
            </ConfirmButton>
          </div>
        </Stack>
      </Stack>

      <Dialog open={!!editingDkId}>
        <DialogContent sx={{ width: 500 }}>
          <BtcUserDk
            navigate={() => {
              setEditingDkId();
            }}
            params={{ id: editingDkId, showDate: false }}
          ></BtcUserDk>
        </DialogContent>
      </Dialog>

      {dkLog && renderLogDlg(dkLog, () => setDkLog())}

      <PdfModal
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        src={dk?.bill}
      />
    </div>
  );
};

